  (function () {
    try {
      let renderTimeout = null;

      function checkAndRenderGICWidget() {
        try {
          if (!window.tlGiftInCartWidget) return;

          const cartForm = document.querySelector('form#mini-cart-form, form[action*="/cart"]');
          const gicContainer = document.querySelector('.salepify-gic__gic-container');

          if (cartForm && !gicContainer) {
            window.tlGiftInCartWidget.updateAllOfferCardsUI();
          }
        } catch (e) {
          console.warn('[Salepify GIC Fix] Error in checkAndRenderGICWidget:', e);
        }
      }

      const observer = new MutationObserver(function () {
        try {
          clearTimeout(renderTimeout);
          renderTimeout = setTimeout(checkAndRenderGICWidget, 150); 
        } catch (e) {
          console.warn('[Salepify GIC Fix] Error in Observer callback:', e);
        }
      });

      function initObserver() {
        try {
          if (document.body) {
            observer.observe(document.body, { childList: true, subtree: true });
            checkAndRenderGICWidget();
          }
        } catch (e) {
          console.warn('[Salepify GIC Fix] Error in initObserver:', e);
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          try {
            initObserver();
          } catch (e) {
            console.warn('[Salepify GIC Fix] Error on DOMContentLoaded:', e);
          }
        });
      } else {
        initObserver();
      }

      window.addEventListener('TLFREEGIFT:update', checkAndRenderGICWidget);
      window.addEventListener('TLFREEGIFT:change', checkAndRenderGICWidget);

    } catch (globalErr) {
      console.warn('[Salepify GIC Fix] Global script error:', globalErr);
    }
  })();
